import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { collection, getDocs, limit, query, where } from "firebase/firestore";
import { db } from "../firebase";
import BusinessResultCard from "../components/BusinessResultCard";
import { EVENT_CATEGORIES, normalizeEventBusiness, categoryMatchesBusiness } from "./EventsHomePage";

function isPublicBusiness(biz) {
  if (!biz || typeof biz !== "object") return false;
  return (
    biz.visible !== false &&
    biz.hidden !== true &&
    biz.isActive !== false &&
    biz.published !== false
  );
}

async function fetchEventBusinesses() {
  const queries = [
    query(collection(db, "businesses"), where("businessType", "in", ["events", "eventos", "Eventos"]), limit(80)),
    query(collection(db, "businesses"), where("type", "in", ["events", "eventos", "Eventos"]), limit(80)),
  ];

  const byId = new Map();

  for (const qBuilt of queries) {
    try {
      const snap = await getDocs(qBuilt);

      snap.docs.forEach((d) => {
        const raw = { id: d.id, ...(d.data() || {}) };
        if (!isPublicBusiness(raw)) return;
        byId.set(d.id, raw);
      });
    } catch (e) {
      console.warn("[EventCategoryPage] query failed", e);
    }
  }

  return Array.from(byId.values())
    .map((raw) => normalizeEventBusiness(raw))
    .filter((b) => b.id);
}

const styles = `
.event-cat-shell{
  min-height:100vh;
  background: radial-gradient(circle at 10% 0%, rgba(0,103,95,.09), transparent 30%), linear-gradient(180deg,#fff 0%,#fbfdfd 48%,#fff 100%);
  padding:28px 18px 90px;
  color:#0f172a;
}
.event-cat-wrap{
  max-width:1180px;
  margin:0 auto;
}
.event-cat-hero{
  display:grid;
  gap:16px;
  padding:18px 0 24px;
  border-bottom:1px solid rgba(203,213,225,.72);
  margin-bottom:22px;
}
.event-cat-topline{
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:12px;
}
.event-cat-back{
  border:1px solid rgba(226,232,240,.95);
  background:rgba(255,255,255,.86);
  color:#334155;
  border-radius:999px;
  min-height:40px;
  padding:0 14px;
  font-size:13px;
  font-weight:950;
  box-shadow:0 10px 24px rgba(15,23,42,.045);
  cursor:pointer;
}
.event-cat-count{
  border:1px solid rgba(0,103,95,.13);
  background:rgba(236,253,245,.82);
  color:#00675f;
  border-radius:999px;
  min-height:38px;
  padding:0 14px;
  display:inline-flex;
  align-items:center;
  font-size:12px;
  font-weight:950;
  white-space:nowrap;
}
.event-cat-kicker{
  display:inline-flex;
  width:fit-content;
  border:1px solid rgba(0,103,95,.16);
  background:rgba(236,253,245,.82);
  color:#00675f;
  border-radius:999px;
  padding:7px 11px;
  font-size:11px;
  font-weight:950;
  letter-spacing:.10em;
  text-transform:uppercase;
  margin-bottom:12px;
}
.event-cat-hero h1{
  margin:0;
  color:#07111f;
  font-size:clamp(42px,5.2vw,72px);
  line-height:.9;
  letter-spacing:-.082em;
  font-weight:950;
}
.event-cat-hero p{
  margin:14px 0 0;
  color:#64748b;
  font-size:16px;
  line-height:1.5;
  font-weight:680;
  max-width:760px;
}
.event-cat-chips{
  display:flex;
  gap:8px;
  overflow-x:auto;
  scrollbar-width:none;
}
.event-cat-chips::-webkit-scrollbar{display:none;}
.event-cat-chips button{
  flex:0 0 auto;
  border:1px solid rgba(226,232,240,.95);
  background:#fff;
  color:#334155;
  border-radius:999px;
  min-height:38px;
  padding:0 14px;
  font-size:13px;
  font-weight:900;
  box-shadow:0 8px 20px rgba(15,23,42,.04);
  cursor:pointer;
}
.event-cat-chips button.active{
  background:#00675f;
  color:#fff;
  border-color:#00675f;
  box-shadow:0 14px 28px rgba(0,103,95,.18);
}
.event-provider-grid{
  display:grid;
  grid-template-columns:repeat(auto-fill,minmax(292px,1fr));
  gap:16px;
}
.event-section-head{
  display:flex;
  align-items:flex-end;
  justify-content:space-between;
  gap:12px;
  margin:0 0 16px;
}
.event-section-head h2{
  margin:0;
  font-size:26px;
  font-weight:950;
  letter-spacing:-.045em;
  color:#0f172a;
}
.event-section-head p{
  margin:6px 0 0;
  color:#64748b;
  font-size:14px;
  font-weight:700;
}
.event-empty{
  padding:28px;
  border-radius:28px;
  background:#fff;
  border:1px solid #e2e8f0;
  color:#64748b;
  font-weight:750;
  box-shadow:0 18px 48px rgba(15,23,42,.055);
}
.event-loading-grid{
  display:grid;
  grid-template-columns:repeat(auto-fill,minmax(292px,1fr));
  gap:16px;
}
.event-loading-grid span{
  min-height:360px;
  border-radius:28px;
  background:linear-gradient(90deg,#f1f5f9 0%,#f8fafc 50%,#f1f5f9 100%);
  background-size:200% 100%;
  animation:eventShimmer 1.25s infinite linear;
}
@keyframes eventShimmer{from{background-position:200% 0;}to{background-position:-200% 0;}}

.event-smart-empty{display:grid;gap:14px;align-items:start;background:radial-gradient(circle at 12% 0%,rgba(20,184,166,.12),transparent 28%),#fff;}
.event-empty-kicker{width:fit-content;border:1px solid rgba(0,103,95,.16);background:rgba(236,253,245,.82);color:#00675f;border-radius:999px;padding:7px 11px;font-size:11px;font-weight:950;letter-spacing:.10em;text-transform:uppercase;}
.event-empty-title{color:#0f172a;font-size:24px;line-height:1.05;letter-spacing:-.045em;font-weight:950;}
.event-empty-copy{margin:0;color:#64748b;font-size:14px;line-height:1.5;font-weight:720;max-width:680px;}
.event-empty-chips{display:flex;gap:8px;flex-wrap:wrap;}
.event-empty-chips button{border:1px solid rgba(0,103,95,.14);background:#fff;color:#0f766e;border-radius:999px;min-height:36px;padding:0 13px;font-size:12.5px;font-weight:900;cursor:pointer;box-shadow:0 8px 20px rgba(15,23,42,.04);}
.event-empty-actions{display:flex;gap:10px;flex-wrap:wrap;}
.event-empty-actions button{border-radius:999px;min-height:42px;padding:0 16px;font-size:13px;font-weight:950;cursor:pointer;}
.event-empty-actions .primary{border:0;background:#00675f;color:#fff;box-shadow:0 14px 28px rgba(0,103,95,.20);}
.event-empty-actions .secondary{border:1px solid #e2e8f0;background:#fff;color:#334155;}

@media(max-width:720px){
  .event-cat-shell{padding:16px 14px calc(96px + env(safe-area-inset-bottom,0px));}
  .event-cat-hero h1{font-size:clamp(38px,11vw,52px);}
  .event-cat-hero p{font-size:14px;}
  .event-section-head{display:block;}
  .event-provider-grid,.event-loading-grid{grid-template-columns:1fr;}
}
`;

export default function EventCategoryPage() {
  const navigate = useNavigate();
  const { categoryKey = "" } = useParams();
  const [businesses, setBusinesses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeChip, setActiveChip] = useState("all");
  const [sortBy, setSortBy] = useState("recommended");

  const category = useMemo(() => {
    return (
      EVENT_CATEGORIES.find((c) => String(c.id).toLowerCase() === String(categoryKey).toLowerCase()) || EVENT_CATEGORIES[0]
    );
  }, [categoryKey]);

  useEffect(() => {
    let active = true;

    async function run() {
      try {
        setLoading(true);
        const all = await fetchEventBusinesses();
        if (!active) return;
        const filtered = all.filter((business) => isPublicBusiness(business) && categoryMatchesBusiness(category, business));
        setBusinesses(filtered);
      } catch (e) {
        console.error(e);
        if (active) setBusinesses([]);
      } finally {
        if (active) setLoading(false);
      }
    }

    run();
    return () => { active = false; };
  }, [category]);

  const shownBusinesses = useMemo(() => {
    const ratingValue = (b) => Number(b.rating || b.averageRating || 0) || 0;
    let list = businesses.slice();
    if (activeChip === "price") list = list.filter((b) => Number(b.fromPrice || b.price || b.basePrice || 0) > 0);
    if (activeChip === "rated") list = list.filter((b) => ratingValue(b) > 0);
    if (sortBy === "rating") list.sort((a, b) => ratingValue(b) - ratingValue(a));
    else if (sortBy === "price") list.sort((a, b) => (Number(a.fromPrice || a.price || a.basePrice || 999999) || 999999) - (Number(b.fromPrice || b.price || b.basePrice || 999999) || 999999));
    else list.sort((a, b) => (b.featured ? 1 : 0) - (a.featured ? 1 : 0) || ratingValue(b) - ratingValue(a));
    return list;
  }, [businesses, activeChip, sortBy]);

  return (
    <>
      <style>{styles}</style>
      <div className="event-cat-shell">
        <div className="event-cat-wrap">
          <section className="event-cat-hero">
            <div className="event-cat-topline">
              <button type="button" className="event-cat-back" onClick={() => navigate(-1)}>← Volver</button>
              <span className="event-cat-count">{loading ? "Cargando..." : `${shownBusinesses.length} negocios`}</span>
            </div>
            <div>
              <span className="event-cat-kicker">Eventos en Loop</span>
              <h1>{category.title}</h1>
              <p>{category.subtitle || "Reserva, cotiza o contacta directo con empresas disponibles para eventos."}</p>
            </div>
            <div className="event-cat-chips" aria-label="Filtros rápidos de eventos">
              <button type="button" className={activeChip === "all" ? "active" : ""} onClick={() => setActiveChip("all")}>Todos</button>
              <button type="button" className={activeChip === "price" ? "active" : ""} onClick={() => setActiveChip("price")}>Con precio</button>
              <button type="button" className={activeChip === "rated" ? "active" : ""} onClick={() => setActiveChip("rated")}>Con reseñas</button>
              <button type="button" className={sortBy === "rating" ? "active" : ""} onClick={() => setSortBy(sortBy === "rating" ? "recommended" : "rating")}>Mejor valorados</button>
              <button type="button" className={sortBy === "price" ? "active" : ""} onClick={() => setSortBy(sortBy === "price" ? "recommended" : "price")}>Menor precio</button>
              {(activeChip !== "all" || sortBy !== "recommended") ? <button type="button" onClick={() => { setActiveChip("all"); setSortBy("recommended"); }}>Limpiar</button> : null}
            </div>
          </section>

          <div className="event-section-head">
            <div>
              <h2>Negocios destacados</h2>
              <p>Opciones disponibles para comparar y reservar desde Loop.</p>
            </div>
          </div>

          {loading ? (
            <div className="event-loading-grid"><span /><span /><span /></div>
          ) : shownBusinesses.length === 0 ? (
            <div className="event-empty event-smart-empty">
              <span className="event-empty-kicker">Explora alternativas</span>
              <div className="event-empty-title">{businesses.length > 0 ? "No hay eventos con estos filtros." : "Todavía no hay negocios publicados para esta categoría."}</div>
              <p className="event-empty-copy">{businesses.length > 0 ? "Limpia los filtros o cambia el orden para ver más opciones." : "Puedes explorar categorías cercanas o volver al marketplace de eventos mientras sumamos más proveedores."}</p>
              <div className="event-empty-chips">
                {EVENT_CATEGORIES.filter((c) => c.id !== category.id).slice(0, 3).map((c) => (
                  <button key={c.id} type="button" onClick={() => navigate(`/events/${c.id}`)}>{c.title}</button>
                ))}
                <button type="button" onClick={() => navigate("/events")}>Todos los eventos</button>
                <button type="button" onClick={() => navigate("/services/search?q=eventos")}>Buscar eventos</button>
              </div>
              <div className="event-empty-actions">
                {(activeChip !== "all" || sortBy !== "recommended") ? (
                  <button type="button" className="primary" onClick={() => { setActiveChip("all"); setSortBy("recommended"); }}>Limpiar filtros</button>
                ) : null}
                <button type="button" className="secondary" onClick={() => navigate("/early-access")}>Sumar mi negocio</button>
              </div>
            </div>
          ) : (
            <div className="event-provider-grid">
              {shownBusinesses.map((business, index) => (
                <BusinessResultCard
                  key={business.id}
                  biz={business}
                  variant="event"
                  priority={index < 3}
                  contextLabel="Evento"
                  actionLabel="Cotizar"
                  onOpenBooking={() => navigate(`/business/${business.id}`)}
                  onOpenBusiness={() => navigate(`/business/${business.id}`)}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
}
